// src/pages/SurveyResults.tsx: route wrapper for the results dashboard.
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProfile } from '../hooks/useProfile';
import { supabase } from '../services/supabase';
import { C } from '../lib/pulse';
import { LoadingScreen, Banner, btnGhost } from '../lib/pulseUI';
import ResultsDashboard from '../lib/ResultsDashboard';

export default function SurveyResults() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { profile, loading: profileLoading } = useProfile();
  const [access, setAccess] = useState<'loading' | 'ok' | 'denied'>('loading');

  const isPB = profile?.is_super_admin === true;

  useEffect(() => {
    if (profileLoading || !id) return;
    if (isPB) { setAccess('ok'); return; }
    // Participants may view once results are published.
    let active = true;
    supabase.from('pulse_surveys').select('id, results_published').eq('id', id).maybeSingle()
      .then(({ data }) => {
        if (!active) return;
        setAccess(data && (data as any).results_published ? 'ok' : 'denied');
      });
    return () => { active = false; };
  }, [id, isPB, profileLoading]);

  if (profileLoading || access === 'loading') return <LoadingScreen label="Loading results…" />;

  return (
    <div style={{ padding: '24px 32px', minHeight: '100vh', background: C.surface }}>
      <button onClick={() => navigate(isPB ? '/pb-survey-admin' : '/pulse-connect')} className="pulse-no-print"
        style={{ ...btnGhost, marginBottom: '16px' }}>← Back</button>
      {access === 'denied'
        ? <Banner type="info" text="Results for this survey have not been published yet. You'll be notified when they're available." />
        : <ResultsDashboard surveyId={id!} isPB={isPB} />}
    </div>
  );
}
